import Button from '../../../components/button/Button';
import { ReactComponent as LoginIcon } from '../../../assets/icons/trvto_login.svg';
import './customHeader.css';
import { useContext, useState } from 'react';
import AnimatedSearchInput from '../../../components/search/SearchInput';
import { UserAuthContext } from '../../../context/UserAuthContext';
import { UserLoginSecContext } from '../../../context/UserLoginSecContext';
import Login from '../../../components/login/login/Login';
import Register from '../../../components/login/register/Register';
import ReactLoading from 'react-loading';
import AccDrop from '../accDrop/AccDrop';
import { ReactComponent as MenuIcon } from '../../../assets/icons/trvto_menu.svg';
import { ReactComponent as AccountIcon } from '../../../assets/icons/trvto_account.svg';
import { ReactComponent as SearchIcon } from '../../../assets/icons/trvto_search.svg';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import trvtoLogo from '../../../assets/images/trvto-logo.png';

const CustomHeader = ({
    leftItems = [],
    centerItems = [],
    rightItems = [],
    logo,
    companyName,
    onLogin,
    onLogout,
    onAccount,
    onSearch,
    searchValue,
    setDebounceSearch
}) => {
    const navigate = useNavigate();
    const location = useLocation();
    const isOrgRoute = location.pathname.startsWith('/orgid');
    const [accountDrop, setAccountDrop] = useState(false);
    const [loading, setLoading] = useState(false);
    const { isAuthenticated } = useContext(UserAuthContext);
    const [search, setSearch] = useState(false);
    const { logButton, setLogButton, loginSec, setLoginSec } = useContext(UserLoginSecContext);
    const tripText = ['Search Your Destination', 'Explore Popular Destinations', 'Find Your Next Adventure'];

    const handleSearch = (query) => {};

    const renderItem = (item) => {
        switch (item) {
            case 'logo':
                return (
                    <div
                        key='logo'
                        className='header-logo'
                        style={{ display: 'flex', alignItems: 'center', gap: '10px' }}
                    >
                        {logo && <img src={logo} alt={companyName || 'Logo'} className='customLogo' />}
                        <h2 className='companyName'>{companyName || 'MyApp'}</h2>
                    </div>
                );
            case 'search':
                return (
                    <div key='search' className='header-search'>
                        <AnimatedSearchInput
                            name='search'
                            value={searchValue}
                            onChange={onSearch}
                            onSubmit={handleSearch}
                            animatePlaceholder={true}
                            placeholderTexts={tripText}
                            type='text'
                            disabled={false}
                        />
                        <span
                            className='tabDisplay'
                            style={{ fontSize: '20px', marginLeft: '10px' }}
                            onClick={() => {
                                setSearch(false);
                                setDebounceSearch('');
                            }}
                        >
                            X
                        </span>
                    </div>
                );
            case 'filter':
                return (
                    <div key='filter' className='header-filter'>
                        <select>
                            <option value=''>Select filter</option>
                            <option value='latest'>Latest</option>
                            <option value='popular'>Popular</option>
                        </select>
                    </div>
                );
            case 'login':
                return isAuthenticated ? (
                    <>
                        <button onClick={() => setAccountDrop(!accountDrop)} className='headerMenuBtn'>
                            <MenuIcon className='headerMenuIcon' />
                        </button>
                        {accountDrop && <div className='headerOverlay' onClick={() => setAccountDrop(false)} />}
                        {accountDrop && (
                            <AccDrop
                                setAccountDrop={setAccountDrop}
                                setLogButton={setLogButton}
                                setLoginSec={setLoginSec}
                            />
                        )}
                        <button className='headerMenuBtn' onClick={() => navigate('/account')}>
                            <AccountIcon className='headerMenuIcon' />
                        </button>
                    </>
                ) : (
                    <Button
                        name='login'
                        onClick={() => {
                            setLogButton(true);
                            setLoginSec('login');
                        }}
                        icon={<LoginIcon />}
                    >
                        Login
                    </Button>
                );

            case 'signup':
                return (
                    <>
                        {!isAuthenticated && (
                            <Button
                                name='signup'
                                onClick={() => {
                                    setLogButton(true);
                                    setLoginSec('register');
                                }}
                                icon={<LoginIcon />}
                            >
                                Sign Up
                            </Button>
                        )}
                    </>
                );
            case 'menuIcons':
                if (!isAuthenticated) {
                    return (
                        <>
                            <button onClick={() => setAccountDrop(!accountDrop)} className='headerMenuBtn'>
                                <MenuIcon className='headerMenuIcon' />
                            </button>

                            {accountDrop && <div className='headerOverlay' onClick={() => setAccountDrop(false)} />}

                            {accountDrop && (
                                <AccDrop
                                    setAccountDrop={setAccountDrop}
                                    setLogButton={setLogButton}
                                    setLoginSec={setLoginSec}
                                />
                            )}
                        </>
                    );
                }
                return null;
            default:
                return null;
        }
    };

    return (
        <div className='header-container'>
            {/* <header className='custom-header'>
                <div className='header-left'>{leftItems.map((item) => renderItem(item))}</div>
                <div className='header-center'>{centerItems.map((item) => renderItem(item))}</div>
                <div className='header-right'>{rightItems.map((item) => renderItem(item))}</div>
            </header> */}
            {/* {logButton && (
                <div className='loginHeaderPop'>
                    {loginSec === 'login' ? (
                        <Login
                            setLogButton={setLogButton}
                            setLoginSec={setLoginSec}
                            setLoading={setLoading}
                            loading={loading}
                        />
                    ) : loginSec === 'register' ? (
                        <Register
                            setLogButton={setLogButton}
                            setLoginSec={setLoginSec}
                            setLoading={setLoading}
                            loading={loading}
                        />
                    ) : null}
                </div>
            )} */}

            {loading && (
                <div className='loadingBackground'>
                    <ReactLoading type='spin' color='#006aff' className='loadingSpin' />
                </div>
            )}
            <div className='headerWrapper headerContainer hideOnPrint'>
                <div className={`${search ? 'tabHidden' : ''}`}>{leftItems.map((item) => renderItem(item))}</div>
                <div className={`header-center ${search ? 'tabDisplay' : 'tabHidden'}`}>
                    {centerItems.map((item) => renderItem(item))}
                </div>
                <div className={`headerTabsEndDiv ${search ? 'tabHidden' : ''}`}>
                    {isOrgRoute && (
                        <button
                            className='headerMenuBtn tabDisplay'
                            onClick={() => {
                                setSearch(true);
                            }}
                        >
                            <SearchIcon className='headerMenuIcon' />
                        </button>
                    )}
                    {rightItems.map((item) => renderItem(item))}
                </div>
                {logButton && (
                    <div className='loginHeaderPop'>
                        {loginSec === 'login' ? (
                            <Login
                                setLogButton={setLogButton}
                                setLoginSec={setLoginSec}
                                setLoading={setLoading}
                                loading={loading}
                            />
                        ) : loginSec === 'register' ? (
                            <Register
                                setLogButton={setLogButton}
                                setLoginSec={setLoginSec}
                                setLoading={setLoading}
                                loading={loading}
                            />
                        ) : null}
                    </div>
                )}
                {loading && (
                    <div className='loadingBackground'>
                        <ReactLoading type='spin' color='#006aff' className='loadingSpin' />
                    </div>
                )}
            </div>
        </div>
    );
};

export default CustomHeader;
